import { render } from "./ViewGridAdd.vue?vue&type=template&id=478e7464"
import script from "./ViewGridAdd.vue?vue&type=script&lang=js"
export * from "./ViewGridAdd.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "478e7464"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('478e7464', script)) {
    api.reload('478e7464', script)
  }
  
  module.hot.accept("./ViewGridAdd.vue?vue&type=template&id=478e7464", () => {
    api.rerender('478e7464', render)
  })

}

script.__file = "src/icons/components/filled/ViewGridAdd.vue"

export default script